import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { array, func, number } from 'prop-types';
import ArrowRight from '../../../../resources/images/arrow-right.svg';
import ArrowLeft from '../../../../resources/images/arrow-left.svg';
import './pagination.scss';

const Pagination = props => {
    const { currentPage, maxPage, pageRangeDisplayed, marginPagesDisplayed, onPageChange } = props;
    const [currentPageValue, setcurrentPageValue] = useState(currentPage);
    let isSingleItem = maxPage === 1 ? 'pagination__item--single' : '';

    useEffect(() => {
        setcurrentPageValue(currentPage - 1);
    }, [currentPage]);

    return (
        <div className="pagination__wrap">
            <ReactPaginate
                nextLabel={<ArrowRight />}
                onPageChange={onPageChange}
                pageRangeDisplayed={pageRangeDisplayed}
                marginPagesDisplayed={marginPagesDisplayed}
                pageCount={maxPage}
                forcePage={currentPageValue}
                previousLabel={<ArrowLeft />}
                pageClassName={`pagination__item ${isSingleItem}`}
                pageLinkClassName="pagination__link"
                previousClassName="pagination__item pagination__item--prev"
                previousLinkClassName="pagination__link"
                nextClassName="pagination__item pagination__item--next"
                nextLinkClassName="pagination__link"
                breakLabel="..."
                breakClassName="pagination__item"
                breakLinkClassName="pagination__link"
                containerClassName="pagination"
                activeClassName="pagination__item--active"
                renderOnZeroPageCount={null}
            />
        </div>
    );
};

Pagination.propTypes = {
    pageRangeDisplayed: number,
    marginPagesDisplayed: number,
    page: number,
    count: number,
    items: array,
    itemsPerPage: number,
    handlePageClick: func
};

Pagination.defaultProps = {
    pageRangeDisplayed: 3,
    marginPagesDisplayed: 1,
    page: 0,
    items: [],
    itemsPerPage: 0,
    handlePageClick: () => {},
    onPageChange: () => {}
};

export default Pagination;
